import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	categoryNameLabel: {
		id: 'business-categories.category-form.category-name-label',
		defaultMessage: 'Category name',
		description: 'Accessibility label for category name input',
	},
	categoryNamePlaceholder: {
		id: 'business-categories.category-form.category-name-placeholder',
		defaultMessage: 'New category',
		description: 'Placeholder text for category name input',
	},
	cancelButton: {
		id: 'business-categories.category-form.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Cancel button text',
	},
	saveButton: {
		id: 'business-categories.category-form.save-button',
		defaultMessage: 'Save',
		description: 'Save button text',
	},
	addButton: {
		id: 'business-categories.category-form.add-button',
		defaultMessage: 'Add',
		description: 'Add button text',
	},
	errorMessageBlankCategoryName: {
		id: 'business-categories.category-form.error-message-blank-category-name',
		defaultMessage: 'Category name cannot be blank',
		description: 'Error message for blank category name',
	},
	errorMessageDuplicateCategoryName: {
		id: 'business-categories.category-form.error-message-duplicate-category-name',
		defaultMessage: "The name you've selected for this category already exists. Try a new name.",
		description: 'Error message for duplicate category name',
	},
	editCategoryTitle: {
		id: 'business-categories.category-form.edit-category-title',
		defaultMessage: 'Edit category',
		description: 'Title for editing category',
	},
	newCategoryTitle: {
		id: 'business-categories.category-form.new-category-title',
		defaultMessage: 'New category',
		description: 'Title for adding category',
	},
});
